import initialState from "reducers/initialState";
import * as types from "./actionTypes";
import * as eventTypes from "./eventTypes";

export default function bankAccountReducer(state = initialState.currentOffer.clientBankAccountData, action) {
  switch (action.type) {
    case types.LOAD_PARTNER_BANK_ACCOUNTS_SUCCEEDED: {
      const partnerId = action.id;
      const bankAccounts = {
        ...state.bankAccounts,
        [partnerId]: {
          partnerId,
          isLoaded: true
        }
      };

      return {
        ...state,
        bankAccounts
      };
    }

    case eventTypes.PARTNER_BANK_ACCOUNTS_INVALIDATED: {
      const { partnerId } = action.event.eventBody;
      const bankAccounts = {
        ...state.bankAccounts,
        [partnerId]: {
          ...state.bankAccounts[partnerId],
          isLoaded: false
        }
      };
      return {
        ...state,
        bankAccounts
      };
    }

    default:
      return state;
  }
}
